/**
 * useCctvPip — 공장 CCTV 라이브 창 열기·닫기(어디서든).
 *
 * 창은 Layout 이 한 번만 그린다(CctvPipHost) → 페이지를 옮겨도 언마운트되지 않아
 * 최소화 창이 영상 연결을 끊지 않고 계속 떠 있다. 큰 창은 페이지를 옮기면 닫는다.
 * Context 대신 모듈 상태 + useSyncExternalStore (useMyAccountModal 과 같은 방식).
 */
import { useSyncExternalStore } from "react";

export interface CctvPipState {
  /** 연 카메라 id. null = 닫힘 */
  camId: string | null;
  /** 썸네일을 누를 때마다 +1 — 같은 카메라를 다시 눌러도 큰 창으로 복귀시키는 신호 */
  seq: number;
  /** 지금 최소화 창인지 (CctvPip 가 알려준다) */
  mini: boolean;
}

let state: CctvPipState = { camId: null, seq: 0, mini: false };
const listeners = new Set<() => void>();

function emit(next: CctvPipState) {
  state = next;
  listeners.forEach((l) => l());
}

/** 썸네일 클릭 — 그 카메라를 화면 중앙 큰 창으로 */
export function openCctvPip(camId: string): void {
  emit({ camId, seq: state.seq + 1, mini: false });
}
export function closeCctvPip(): void {
  if (state.camId === null) return;
  emit({ ...state, camId: null, mini: false });
}
export function setCctvPipMini(mini: boolean): void {
  if (state.mini === mini) return;
  emit({ ...state, mini });
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
function snapshot() {
  return state;
}

export function useCctvPip(): CctvPipState {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
